<template >
  <div class="classDialog">
    <el-dialog :title="title" :visible.sync="classDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="classForm" :model="classForm"  label-width="140px" :rules="rules">
        <!-- <el-form-item label="所属学段"  class="is-required"  prop="stageId">
          <el-select v-model="classForm.stageId"  placeholder="请选择">
            <el-option :label="item.name" :value="item.id"   v-for="(item,index ) in stages"  :key="index" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="科目名称"  class="is-required" prop="name">
          <el-input v-model.trim="classForm.name" maxlength="32" placeholder="请输入科目名称"> </el-input>
        </el-form-item>
        <el-form-item label="排序值"  class="is-required" prop="ordinal">
          <el-input v-model.trim="classForm.ordinal" placeholder="请输入排序值..." maxlength="9"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import classService from '@/service/classService'
import commonService from '@/service/commonService'
export default {
  props: {
    id: {
      type: Number
    },
    stageId: Number,
    rowData: Object,
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      title: '新增科目',
      loading: false,
      stages: [],
      classForm: {
        name: '',
        stageId: 0,
        ordinal: '',
        id: '',
        used: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入科目名称', trigger: ['blur', 'change']}
        ],
        stageId: [
          {required: true, message: '请选择所属学段', trigger: ['blur', 'change']}
        ],
        ordinal: [
          {required: true, message: '请输入序列号', trigger: 'blur'},
          {pattern: /^[0-9]*$/, message: '请输入数字', trigger: ['blur', 'change']}
        ]
      }
    }
  },
  async mounted () {
    await this.fetchLearnData()
  },
  methods: {
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          this.classForm.stageId = data[0].id
          this.stages = data
        } else {
          this.stages = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    save () {
      this.loading = true
      this.$refs.classForm.validate(async valid => {
        if (valid) {
          try {
            await classService.save(this.classForm)
            // 重置表单
            // this.$refs.classForm.resetFields()
            Object.keys(this.classForm).forEach(key => this.classForm[key] = '')
            this.$emit('success')
            this.loading = false
            this.classDialogVisible = false
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    classDialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.classForm) {
          // this.$refs.classForm.resetFields()
          Object.keys(this.classForm).forEach(key => this.classForm[key] = '')
        }
        // 加载初始化数据
        if (this.$props.id) {
          this.title = '编辑科目'
          // console.log(this.$props.rowData)
          // this.classForm = this.$props.rowData
          this.classForm.name = this.$props.rowData && this.$props.rowData.name
          this.classForm.stageId = this.$props.rowData && this.$props.rowData.stageId
          this.classForm.ordinal = this.$props.rowData && this.$props.rowData.ordinal
          this.classForm.id = this.$props.rowData && this.$props.rowData.id
          this.classForm.used = this.$props.rowData && this.$props.rowData.used
        } else {
          this.classForm.name = ''
          this.classForm.stageId = this.$props.stageId
          this.title = '新增科目'
        }
      }
    }
  },
  computed: {
    classDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
  .classDialog .el-input{
    width:80%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/class-manage/edit-dialog/index.vue